/* eslint-disable react/no-array-index-key */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
import moment from 'moment';
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { ArrowBackIosNew, ArrowForwardIos } from '@mui/icons-material';
import { Box, LinearProgress } from '@mui/material';
import { indexOf } from 'lodash';
import MonthHeader from './MonthHeader';
import WeekHeader from './WeekHeader';
import Week from './Week';
import Day from './Day';
import DayAppointments from './DayAppointments';

import './styles.css';

import commonUtils from '../../utils/commonUtils';

export default function AppointmentCalendar({
  initDate,
  selectedDate = [],
  appointments = [],
  isCount = false,
  loading = false,
  onChangeDate,
  onShowMore,
  onClickDate,
  clickableDate,
  isDisableNavigation,
  className,
}) {
  const currentDate = moment().format('YYYY-MM-DD');
  const [calendarDate, setCalendarDate] = useState(moment().format('YYYY-MM-01'));
  const [width, setWidth] = useState(0);
  const [height, setHeight] = useState(0);
  const ref = useRef(null);

  useEffect(() => {
    setCalendarDate(initDate);
  }, [initDate]);

  useEffect(() => {
    setWidth(ref.current.clientWidth);
    setHeight(ref.current.clientWidth * 0.6);
  });

  const handleClickNext = () => {
    const newDate = moment(calendarDate).add(1, 'months').format('YYYY-MM-01');
    setCalendarDate(newDate);

    onChangeDate(newDate);
  };

  const handleClickPrev = () => {
    const newDate = moment(calendarDate).subtract(1, 'months').format('YYYY-MM-01');
    setCalendarDate(newDate);
    onChangeDate(newDate);
  };

  const parseCellData = () => {
    const firstDay = moment(calendarDate).startOf('month').format('d');
    const daysInMonth = moment(calendarDate).daysInMonth();
    const yearMonth = moment(calendarDate).format('YYYY-MM');
    const cells = [];

    for (let i = 0; i < firstDay; i++) {
      cells.push({ id: commonUtils.generateUUID(), isDate: false });
    }

    for (let i = 1; i <= daysInMonth; i++) {
      const cellDate = `${yearMonth}-${i < 10 ? `0${i}` : i}`;
      const cellAppointments = appointments.filter((row) => row.date === cellDate);

      let showAppointments = [];
      let showMore = false;
      let showMoreRemaining = 0;

      let noOfAppointmentsShowed = 3;

      showAppointments = [];
      showMore = true;
      showMoreRemaining = cellAppointments.length;

      if (width <= 350) {
        noOfAppointmentsShowed = 0;
      } else if (width <= 460) {
        noOfAppointmentsShowed = 1;
      } else if (width <= 630) {
        noOfAppointmentsShowed = 2;
      }
      showAppointments = cellAppointments.slice(0, noOfAppointmentsShowed);

      showMore = cellAppointments.length > noOfAppointmentsShowed;
      showMoreRemaining = showMore ? cellAppointments.length - noOfAppointmentsShowed : 0;

      // check if date is current date

      const tmp = {
        id: commonUtils.generateUUID(),
        isDate: true,
        isCurrentDate: currentDate === cellDate,
        isSelectedDate: Array.isArray(selectedDate)
          ? selectedDate.includes(cellDate)
          : selectedDate === cellDate,
        date: cellDate,
        label: i,
        appointments: cellAppointments,
        showAppointments,
        total: cellAppointments.length,
        showMore,
        showMoreRemaining,
        isCount,
      };

      cells.push(tmp);
    }

    const lastCellsBlank = cells.length > 35 ? 42 - cells.length : 35 - cells.length;

    if (lastCellsBlank) {
      for (let i = 0; i < lastCellsBlank; i++) {
        cells.push({ id: commonUtils.generateUUID(), isDate: false });
      }
    }

    return cells;
  };

  const renderWeeks = () => {
    const cellData = parseCellData();
    const rows = [...Array(cellData.length / 7)].map((_, i) => cellData.slice(7 * i, 7 + 7 * i));

    return rows.map((cells) => {
      const uuid = commonUtils.generateUUID();

      return (
        <Week key={uuid}>
          {cells.map((cell, index) => (
            <Day data={cell} key={index}>
              {loading ? (
                <span />
              ) : (
                <DayAppointments
                  data={cell}
                  onShowMore={onShowMore}
                  onClickDate={onClickDate}
                  clickableDate={clickableDate}
                />
              )}
            </Day>
          ))}
        </Week>
      );
    });
  };

  return (
    <div className={`event-calendar-container ${className}`}>
      <table className='ecc-month-header'>
        <tbody>
          <tr>
            <td>
              {isDisableNavigation ? null : (
                <button
                  className='ecc-button ecc-button-prev'
                  type='button'
                  onClick={handleClickPrev}
                >
                  <ArrowBackIosNew />
                </button>
              )}
            </td>
            <td>
              <MonthHeader date={calendarDate} />
            </td>
            <td>
              {isDisableNavigation ? null : (
                <button
                  className='ecc-button ecc-button-next'
                  type='button'
                  onClick={handleClickNext}
                >
                  <ArrowForwardIos />
                </button>
              )}
            </td>
          </tr>
        </tbody>
      </table>
      <WeekHeader />
      {loading ? <LinearProgress /> : null}

      <div ref={ref}>
        {width ? (
          <table className='ec-weeks-table' style={{ width, height }}>
            <tbody>{renderWeeks()}</tbody>
          </table>
        ) : (
          `Loading ...`
        )}
      </div>
    </div>
  );
}

AppointmentCalendar.defaultProps = {
  initDate: moment().format('YYYY-MM-DD'),
  // selectedDate: [],
  appointments: [],
  loading: false,
  isCount: false,
  isDisableNavigation: false,
  onChangeDate: () => {},
  onShowMore: () => {},
  onClickDate: null,
  className: '',
  clickableDate: false,
};

AppointmentCalendar.propTypes = {
  initDate: PropTypes.string,
  // eslint-disable-next-line react/require-default-props, react/forbid-prop-types
  selectedDate: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  // eslint-disable-next-line react/require-default-props, react/forbid-prop-types
  appointments: PropTypes.array,
  loading: PropTypes.bool,
  isCount: PropTypes.bool,
  isDisableNavigation: PropTypes.bool,
  onChangeDate: PropTypes.func,
  onShowMore: PropTypes.func,
  className: PropTypes.string,
  onClickDate: PropTypes.func,
  clickableDate: PropTypes.bool,
};
